import { Upload, Image as ImageIcon, Trash2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

/**
 * Image Upload Card with dropzone
 */
export function ImageUploadCard({ 
  preview, 
  selectedFile, 
  getRootProps, 
  getInputProps, 
  isDragActive, 
  onClear 
}) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <ImageIcon className="w-5 h-5 text-blue-500" />
          Last opp bilde
        </CardTitle>
        <CardDescription>
          Støtter PNG, JPG, JPEG, TIFF (maks 10MB)
        </CardDescription>
      </CardHeader>
      <CardContent>
        {!preview ? (
          <div
            {...getRootProps()}
            className={`border-2 border-dashed rounded-xl p-8 text-center cursor-pointer transition-colors
              ${isDragActive 
                ? 'border-teal-500 bg-teal-50' 
                : 'border-slate-200 hover:border-teal-400 hover:bg-slate-50'
              }`}
          >
            <input {...getInputProps()} />
            <Upload className="w-12 h-12 mx-auto text-slate-400 mb-3" />
            {isDragActive ? (
              <p className="text-teal-600 font-medium">Slipp bildet her...</p>
            ) : (
              <>
                <p className="text-slate-600 font-medium">Dra og slipp et bilde her</p>
                <p className="text-sm text-slate-400 mt-1">eller klikk for å velge fil</p>
              </>
            )}
          </div>
        ) : (
          <div className="space-y-4">
            <div className="relative rounded-xl overflow-hidden bg-slate-100">
              <img 
                src={preview} 
                alt="Preview" 
                className="w-full h-64 object-contain"
              />
              <Button
                variant="destructive"
                size="sm"
                className="absolute top-2 right-2"
                onClick={onClear}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-slate-600">{selectedFile?.name}</span>
              <span className="text-slate-400">
                {(selectedFile?.size / 1024).toFixed(1)} KB
              </span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
